import { toISOString, toDate } from './timestamp';

const PREMIUM_TYPES = new Set(['premium', 'paid', 'pro', 'plus']);

const textType = (...values) =>
  String(values.find((value) => value !== undefined && value !== null && value !== '') || '')
    .trim()
    .toLowerCase();

const firstValue = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== '');

const parseOnOff = (...values) => {
  for (const value of values) {
    if (value === undefined || value === null || value === '') continue;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value !== 0;
    const text = String(value).trim().toLowerCase();
    if (['on', 'true', 'yes', '1', 'enabled'].includes(text)) return true;
    if (['off', 'false', 'no', '0', 'disabled'].includes(text)) return false;
  }
  return null;
};

export const isPremiumUser = (user = {}) => {
  const type = textType(
    user.subscriptionType,
    user.plan,
    user.type,
    user.subscription?.type,
    user.subscription?.subscriptionType
  );

  return (
    user.isActive === true ||
    user.isPremium === true ||
    PREMIUM_TYPES.has(type)
  );
};

export const isActivePremium = (user = {}) => {
  if (!isPremiumUser(user)) return false;
  if (user.isActive === true) return true;

  const expiry = toDate(user.subscriptionExpiry || user.expiryDate || user.expiresAt);
  if (expiry && !Number.isNaN(expiry.getTime())) {
    return expiry > new Date();
  }
  return true;
};

export const mapUserDoc = (id, data = {}, subscription = null) => {
  const sub = subscription || {};
  const type = textType(
    sub.type,
    sub.subscriptionType,
    sub.plan,
    data.subscriptionType,
    data.plan,
    data.type
  );
  const isPremium =
    sub.isActive === true ||
    data.isActive === true ||
    data.isPremium === true ||
    sub.isPremium === true ||
    PREMIUM_TYPES.has(type);

  return {
    ...data,
    id,
    uid: id,
    username: data.username || data.userName || data.displayName || id,
    email: data.email || '',
    fullName: data.fullName || data.name || data.displayName || '',
    status: data.status || data.accountStatus || 'active',
    subscriptionType: isPremium ? 'premium' : 'free',
    subscriptionExpiry: toISOString(
      firstValue(
        sub.expiryDate,
        sub.subscriptionExpiry,
        sub.expiresAt,
        sub.expirationDate,
        sub.expireDate,
        sub.endDate,
        sub.currentPeriodEnd,
        sub.validUntil,
        data.subscriptionExpiry,
        data.expiryDate,
        data.expiresAt,
        data.expirationDate,
        data.endDate
      )
    ),
    autoRenewal: (() => {
      const stored = parseOnOff(
        sub.autoRenewal,
        sub.autoRenew,
        sub.willRenew,
        sub.willAutoRenew,
        sub.isAutoRenew,
        sub.renews,
        data.autoRenewal,
        data.autoRenew,
        data.willRenew,
        data.willAutoRenew
      );
      if (stored !== null) return stored;
      return sub.isActive === true;
    })(),
    planId: typeof sub.planId === 'string' ? sub.planId : data.planId || null,
    isActive: sub.isActive === true || data.isActive === true || isPremium,
    isPremium,
    registeredAt: toISOString(data.createdAt || data.registeredAt || data.created_at),
    lastLogin: toISOString(data.lastLogin || data.lastLoginAt || data.last_login),
    deletedAt: toISOString(data.deletedAt),
    updatedAt: toISOString(data.updatedAt),
    ipAddress: data.ipAddress || data.ip || '',
    promoCodeUsed: sub.promoCodeUsed || data.promoCodeUsed || null,
    birthdate: data.birthdate || data.dateOfBirth || null,
  };
};
